import { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

type Props = {
  children: ReactNode
  extraClassName?: string
}

const ShadowCard = ({
  children,
  extraClassName = 'p-8 md:p-12 gap-4',
}: Props) => {
  const cls = twMerge(
    'bg-white border-gray-700 shadow-md rounded-md bright:border leading-relaxed grid auto-rows-max',
    extraClassName,
  )

  return <div className={cls}>{children}</div>
}

export default ShadowCard
